import React from 'react'
import { Theme, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import FirstPageRounded from '@mui/icons-material/FirstPageRounded'
import LastPageRounded from '@mui/icons-material/LastPageRounded'
import NavigateBeforeRounded from '@mui/icons-material/NavigateBeforeRounded'
import NavigateNextRounded from '@mui/icons-material/NavigateNextRounded'
import { useSelector } from 'react-redux'
import { getTheme } from '../../../store/common/common.selectors'

type IProps = {
	totalItems: number
	itemsPerPage: number
	page: number
	setPage: (page: number) => void
};

const useStyles = makeStyles((theme: Theme) => ({
  pagination: {
    margin: '0',
    display: 'flex',
    padding: 0,
    flexWrap: 'wrap',
    listStyle: 'none',
    alignItems: 'center',
  },
  pageItem: {
    fontFamily: theme.typography.fontFamily,
  },
  pageLink: {
    margin: '0 1px',
  },
  disabled: {
    opacity: 0.38,
    pointerEvents: 'none',
    cursor: 'default',
  },
}))

export default function PaginationContainer(props: IProps) {
  const { totalItems, itemsPerPage, page, setPage } = props
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const classes = useStyles()
  const { t } = useTranslation()
  const theme: Theme = useSelector(getTheme)

  const onFirstPage = (): void => {
    setPage(1)
  }

  const onLastPage = (): void => {
    setPage(totalPages)
  }

  const onNextPage = (): void => {
    setPage(page + 1)
  }

  const onPreviousPage = (): void => {
    setPage(page - 1)
  }

  const getItemsCounter = () => {
    let fromTo = ''
    if (page === 1) {
      fromTo = `${page}-${itemsPerPage}`
    } else if (page > 1 && page !== totalPages) {
      fromTo = `${((itemsPerPage * page) - itemsPerPage) + 1}-${itemsPerPage * page}`
    } else {
      fromTo = `${(itemsPerPage * page) - (itemsPerPage - 1)}-${totalItems}`
    }
    return `${fromTo} ${t('coreDashboard:of')} ${totalItems}`
  }

  return (
    <>
      {totalItems > itemsPerPage && (
        <nav style={{ marginTop: theme.spacing(2) }}>
          <ul className={classes.pagination}>
            <li className={`${classes.pageItem}`} style={{ marginRight: theme.spacing(3) }}>
              {getItemsCounter()}
            </li>
            <li className={`${classes.pageItem}`}>
              <IconButton
                className={`${classes.pageLink} ${page === 1 && classes.disabled}`}
                color="primary"
                component="div"
                onClick={() => onFirstPage()}
                size="large"
              >
                <FirstPageRounded/>
              </IconButton>
            </li>
            <li className={`${classes.pageItem}`}>
              <IconButton
                className={`${classes.pageLink} ${page === 1 && classes.disabled}`}
                color="primary"
                component="div"
                onClick={() => onPreviousPage()}
                size="large"
              >
                <NavigateBeforeRounded/>
              </IconButton>
            </li>
            <li className={`${classes.pageItem}`}>
              <IconButton
                className={`${classes.pageLink} ${page === totalPages && classes.disabled}`}
                color="primary"
                component="div"
                onClick={() => onNextPage()}
                size="large"
              >
                <NavigateNextRounded/>
              </IconButton>
            </li>
            <li className={`${classes.pageItem}`}>
              <IconButton
                className={`${classes.pageLink} ${page === totalPages && classes.disabled}`}
                color="primary"
                component="div"
                onClick={() => onLastPage()}
                size="large"
              >
                <LastPageRounded/>
              </IconButton>
            </li>
          </ul>
        </nav>
      )}
    </>
  )
}
